export function getUltimaActuacion(item) {
  let actuacion = null;

  if (item?.imponibles?.length) {
    const imponibles = item.imponibles.filter(e => e?.actuaciones?.length);
    const imponible = imponibles[imponibles.length - 1];

    if (imponible?.actuaciones?.length) {
      const actuaciones = imponible.actuaciones.sort((a, b) => new Date(a?.fecha).getTime() - new Date(b?.fecha).getTime());
      actuacion = actuaciones[actuaciones.length - 1];
    }

    let historicos = item?.imponibles.map((e) => e?.historico).filter(e => e).sort((a, b) => new Date(a?.fecha).getTime() - new Date(b?.fecha).getTime());

    if (historicos?.length) {
      const historico = historicos[historicos.length - 1];

      if (!actuacion || new Date(historico?.fecha) > new Date(actuacion?.fecha)) {
        actuacion = historico;
      }
    }
  }

  return actuacion;
}